import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 043DEA8B-1F5B-49CE-BC9F-AA3FC802A58A
 * name flashlight-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flashlight-off.svg
 * tags
 */
export const FlashlightOffIcon = createSvgIcon(<><path d="M2,5.27L3.28,4L20,20.72L18.73,22L15,18.27V22H9V12.27L2,5.27M18,5L15,10H11.82L6.82,5H18M18,4H6V2H18V4M15,11V13.18L12.82,11H15Z" /></>, 'FlashlightOffIcon');
export default FlashlightOffIcon